import * as restGateway from "./restGatewayApi";

export const getImage = (_id) => {
    
    return restGateway.generateFullUrl(`resource/image/`) + _id;
}
